import React, { Fragment, Component } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import EnquiriesTable from "./components/table";
import Service from "../../services/clientService";
import DateRangePicker from "../../components/common/dateRangePicker";
import Search from "../../components/common/search";
import BrandCategoryService from "../../services/brandCategoryService";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import $ from "jquery";
// import store from "store";

class Enquiry extends Component {
  state = {
    infoData: [],
    info: { sUrl: "" },
    brandsList: [],
    categoryList: [],
  };
  componentWillMount() {
    const { match } = this.props;
    const { params } = match;
    const { clientId } = params;
    this.setState({ loader: true, clientId }, function () {
      BrandCategoryService.fetchBrandCategoryInfo().then((response) => {
        if (!response.error) {
          this.setState(
            {
              loader: true,
              brandsList: response.brandList,
              categoryList: response.categoryList,
            },
            function () {
              this.callApiInfo();
            }
          );
        }
      });
    });
  }
  componentDidUpdate() {
    const { match } = this.props;
    const { params } = match;
    const { enquiryStatus, clientId } = params;
    if (
      this.state.enquiryStatus !== enquiryStatus ||
      this.state.clientId !== clientId
    ) {
      this.setState(
        {
          loader: true,
          infoData: [],
          searchText: "",
          page: 0,
          pageSize: 10,
          totalRecords: 0,
          startDate: "",
          endDate: "",
          enquiryStatus: enquiryStatus,
          clientId: clientId,
        },
        function () {
          this.callApiInfo();
        }
      );
    }
  }
  callApiInfo = () => {
    const {
      enquiryStatus,
      page,
      pageSize,
      searchText,
      startDate,
      endDate,
      clientId,
    } = this.state;
    Service.fetchEnquiriesInfo(
      undefined,
      clientId,
      enquiryStatus,
      page,
      pageSize,
      searchText,
      startDate,
      endDate
    ).then((response) => {
      if (!response.error) {
        var totalRecords = Math.ceil(response.totalRecords / pageSize);
        console.log({ response: response.data });
        this.setState({
          modalFormShow: false,
          loader: false,
          infoData: response.data,
          totalRecords: totalRecords,
        });
      } else {
        this.setState({
          loader: false,
          infoData: [],
          totalRecords: 0,
        });
      }
    });
    this.setState({ loader: false });
  };
  onClickToggle = () => {
    this.setState({ modalFormShow: false });
  };
  onSearchText = (searchText) => {
    this.setState(
      {
        page: 0,
        searchText: searchText,
        startDate: "",
        endDate: "",
      },
      function () {
        if (searchText && searchText !== "" && searchText.length > 0) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };
  onSearchDate = (startDate, endDate) => {
    this.setState(
      {
        page: 0,
        searchText: "",
        startDate: startDate,
        endDate: endDate,
      },
      function () {
        if (startDate && endDate) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };
  onChangePageSize = (pageSize) => {
    this.setState(
      {
        pageSize: pageSize,
      },
      function () {
        if (pageSize) {
          $.ajaxQ.abortAll();
          this.callApiInfo();
        }
      }
    );
  };
  onChangePage = (page) => {
    this.setState(
      {
        page: page,
      },
      function () {
        $.ajaxQ.abortAll();
        this.callApiInfo();
      }
    );
  };
  onChangeImage = (imageUrl) => {
    this.setState({ imageUrl: imageUrl });
  };

  removeImage = () => {
    this.setState({ imageUrl: undefined });
  };

  onChangeActive = (enquiryId, value, index) => {
    console.log({ enquiryId, value });
    const { infoData } = this.state;
    this.setState({ loader: true });
    // Service.onCategoryReady(enquiryId, value).then((response) => {
    //   if (!response.error) {
    //     infoData[index].public = value;
    //     this.setState({ infoData, loader: false });
    //     // this.props.history.push("/products/all");
    //   }
    //   this.setState({ loader: false });
    // });
  };
  render() {
    const {
      enquiryStatus,
      clientId,
      infoData,
      modalFormShow,
      loader,
      info,
      index,
      isEdit,
      imageUrl,
      brandsList,
      categoryList,
    } = this.state;
    const { loading, page, pageSize, totalRecords } = this.state;

    const propsTable = {
      brandsList,
      categoryList,
      enquiryStatus: enquiryStatus,
      multiSelectOption: false,
      myData: infoData,
      loading: loading,
      pageSize: pageSize,
      page: page,
      totalRecords: totalRecords,
      // pageSize: infoData.length < 10 ? infoData.length : 10,
      pagination: true,
      onChangeActive: this.onChangeActive,
      onEditInfo: (index, info) => {
        // this.props.history.push("/categories/" + info._id + "/update");
      },
      onChangePageSize: (pageSize) => {
        //console.log({ pageSize });
        this.onChangePageSize(pageSize);
      },
      onChangePage: (page) => {
        this.onChangePage(page);
      },
      deactivateMember: (staffMemberId) => {
        this.memberDeactivate(staffMemberId);
      },
      handleInfoEdit: (info) => {
        //console.log({info})
        this.dealerInfoEdit(info);
      },
    };
    const propsSearchText = {
      searchText: this.state.searchText,
      onChangeText: (searchText) => {
        this.onSearchText(searchText);
      },
    };
    return (
      <Fragment>
        <Breadcrumb
          title={enquiryStatus ? clientId : "Client"}
          parent="Enquiries"
        />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                {loader && (
                  <div
                    style={{
                      position: "fixed",
                      top: "50%",
                      right: "45%",
                      zIndex: "+999",
                    }}
                  >
                    <div className="loader bg-white">
                      <div className="whirly-loader"> </div>
                    </div>
                  </div>
                )}
                <div className="card-body datatable-react">
                  <div className="row m-b-10">
                    <div className="col-sm-4"></div>
                    <div className="col-sm-4">
                      {/* <Search {...propsSearchText} /> */}
                    </div>

                    <div className="col-sm-4" style={{ marginTop: "10px" }}>
                      {/* <DateRangePicker {...propsDaterangePicker} /> */}
                    </div>
                  </div>
                  {/* {infoData && infoData.length > 0 && ( */}
                  <EnquiriesTable
                    {...propsTable}
                    className="-striped -highlight"
                  />
                  {/* )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Enquiry;
